import { DestinationUrlSetting } from './destination-url-setting';
import { EventParamSetting } from './event-param-setting';
import { AppInstallSetting } from './app-install-setting';
import { DurationSetting } from './duration-setting';
import { PageViewSetting } from './pageview-setting';
import { ClarityEventSetting } from './clarity-event-setting';

const noViewGoals = ['InStoreTransactionGoal', 'OfflineConversionGoal', 'ProductConversionGoal', 'InStoreVisitGoal'];
const claritySetupHiddenSettingsGoals = ['EventGoal'];
const specificViewGoals = {
  DestinationGoal: DestinationUrlSetting,
  EventGoal: EventParamSetting,
  ApplicationInstallGoal: AppInstallSetting,
  DurationGoal: DurationSetting,
  PageViewsPerVisitGoal: PageViewSetting,
  ClarityEventGoal: ClarityEventSetting,
};

const EmptyReactView = () => null;

export const getSpecificGoalSettings = (goalType, isClaritySetupEnabled) => {
  if (noViewGoals.indexOf(goalType) > -1) {
    return EmptyReactView;
  }
  if (isClaritySetupEnabled && claritySetupHiddenSettingsGoals.indexOf(goalType) > -1) {
    return EmptyReactView;
  }

  return specificViewGoals[goalType];
};
